import React, { Fragment } from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicCheckbox, Loader } from 'core/components';

const NeverShippedTemplate = ({
	t,
	neverShippedViewStore: {
		onCheck,
		loading,
		voidOnChannel,
		closeModal,
		markNeverShipped,
		isBulkAction,
		showVoidOnChannel,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<div className="ReactModal__header">
				<p className="spc--bottom--sml">
					{isBulkAction ? t('ORDERVIEW.CONFIRMNEVERSHIPPEDBULK') : t('ORDERVIEW.CONFIRMNEVERSHIPPED')}
				</p>
				{showVoidOnChannel && (
					<div className="spc--bottom--sml">
						<label className="display--b">{t('VOIDLABELCONFIRMATIONVIEW.VOIDONCHANNEL')}</label>
						<Fragment>
							<BaasicCheckbox
								id={'voidOnChannel'}
								onChange={onCheck}
								checked={voidOnChannel}
								className="input--toggle input--toggle--secondary"
							/>
						</Fragment>
					</div>
				)}
			</div>
			<div className="ReactModal__footer">
				<button className="btn btn--med btn--primary spc--bottom--sml" onClick={markNeverShipped}>
					{t('SAVE')}
				</button>
				<button className="btn btn--med btn--ghost spc--bottom--sml" onClick={closeModal}>
					{t('CANCEL')}
				</button>
			</div>
		</section>
	);
};

export default defaultTemplate(NeverShippedTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/NeverShippedTemplate.jsx